import cypressIds from 'Components/cypress_ids.json';
import { ShortlistButton } from 'Components/shared/ShortlistButton/ShortlistButton';
import TextLink from 'Components/shared/TextLink/TextLink';
import { VrmWithCopy } from 'Components/VrmWithCopy/VrmWithCopy';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { ANALYTICS_CATEGORIES } from 'Services/analytics/analytics.const';
import {
	triggerRecommendedSeeAllVehiclesClicked,
	triggerShortlistVehicleShortlistClickedEvent,
	triggerVrmCopiedEvent,
} from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';
import ROUTES from 'Utilities/routes';

import { useBiddingViewName } from '../../BiddingSection/useBiddingViewName';
import { useSimilarVehiclesContext } from '../../SimilarVehiclesSection/SimilarVehiclesProvider/SimilarVehiclesProvider';
import { useVehicleMainInfo } from '../useVehicleMainInfo';

import { VALID_SHORTLIST_BUTTON_VIEW_NAMES } from './VrmSection.const';

import styles from './VrmSection.module.scss';

export const VrmSection: React.FC = () => {
	const { isSimilarVehiclesSectionVisible, setIsSimilarVehiclesModalOpen } = useSimilarVehiclesContext();
	const { id: vehicleId } = useVehicleData();
	const biddingViewName = useBiddingViewName();
	const { prettyVrm } = useVehicleMainInfo();

	const shouldShowShortlistButton = VALID_SHORTLIST_BUTTON_VIEW_NAMES.includes(biddingViewName);

	const onClick = () => {
		setIsSimilarVehiclesModalOpen(true);
		triggerRecommendedSeeAllVehiclesClicked(ROUTES.VEHICLE.as(vehicleId));
	};

	return (
		<div className={styles.section}>
			<div className={styles.left}>
				<VrmWithCopy
					onCopyClicked={() => triggerVrmCopiedEvent({ category: ANALYTICS_CATEGORIES.VEHICLE_DETAILS })}
					vrm={prettyVrm}
				/>
				{shouldShowShortlistButton ? (
					<ShortlistButton
						id={vehicleId}
						onClickShortlist={({ id, isChecked, page }) =>
							triggerShortlistVehicleShortlistClickedEvent({ id, isChecked, page })
						}
						page="vehicle details page"
					/>
				) : null}
			</div>
			{isSimilarVehiclesSectionVisible && (
				<div className={styles.right}>
					<TextLink
						classNames={{ container: styles.link, text: styles.text }}
						onClick={onClick}
						onKeyPress={onClick}
						tabIndex={0}
						text="You might also like"
						{...applyCypressData(cypressIds.links.youMightAlsoLike)}
					/>
				</div>
			)}
		</div>
	);
};
